import { useQuery, useMutation } from "@tanstack/react-query";
import { apiClient } from "api/apiClient.ts";

// Sign-up Mutation
export const useSignUp = () => {
  return useMutation({
    mutationFn: async (formData: any) => {
      const { data } = await apiClient.post("/auth/register", formData);
      return data;
    },
  });
};

// Login Mutation
export const useLogin = () => {
  return useMutation({
    mutationFn: async ({ email, password }: any) => {
      const { data } = await apiClient.post("/auth/login", { email, password });
      return data;
    },
  });
};

// Update User Info
export const useUpdateUser = () => {
  return useMutation({
    mutationFn: async (userData: any) => {
      const { data } = await apiClient.patch("/user/updateMyInfo", userData);
      return data;
    },
  });
};

// Create an Order
export const useCreateOrder = () => {
  return useMutation({
    mutationFn: async (orderData: any) => {
      const { data } = await apiClient.post("/orders/create", orderData);
      return data;
    },
  });
};

// Get All Orders
export const useGetOrders = () => {
  return useQuery({
    queryKey: ["orders"],
    queryFn: async () => {
      const { data } = await apiClient.get("/orders/my-orders");
      return data.data.orders;
    },
  });
};

// Get All Mosques
export const useGetMosques = () => {
  return useQuery({
    queryKey: ["mosques"],
    queryFn: async () => {
      const { data } = await apiClient.get("/mosques");
      return data.data.mosques;
    },
  });
};
